<div class="row">
    <div class="col-12" style="margin-top: 100px;">

    </div>
</div>
<!-- <section class="ftco-section ftco-section-2 bg-light">
    <div class="container">
        <div class="row no-gutters justify-content-center">
            <div class="col-md-12">
                <div class="wrapper">
                    <div class="row g-0">
                        <div class="col-lg-12">
                            <div class="contact-wrap w-100 p-md-5 p-4">
                                <h3>
                                    Contact us
                                </h3>
                                <p class="mb-4">We're open for any suggestion or just to have a chat</p>
                                <div class="row mb-4">
                                    <div class="col-md-4">
                                        <div class="dbox w-100 d-flex align-items-start">
                                            <div class="text">
                                                <p><span>Address:</span> 198 West 21th Street, Suite 721 New York NY
                                                    10016</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="dbox w-100 d-flex align-items-start">
                                            <div class="text">
                                                <p><span>Email:</span> <a
                                                        href="mailto:customercare@direkt.ae">customercare@direkt.ae</a></p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="dbox w-100 d-flex align-items-start">
                                            <div class="text">
                                                <p><span>Phone:</span> <a href="tel://1234567920">+ 1235 2355 98</a></p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <form [formGroup]="contactForm" (ngSubmit)="onSubmit()">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <input type="text" class="form-control" name="name" id="name"
                                                    placeholder="Name" formControlName="name">
                                            </div>
                                        </div>
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <input type="email" class="form-control" name="email" id="email"
                                                    placeholder="Email" formControlName="email">
                                            </div>
                                        </div>
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <input type="text" class="form-control" name="subject" id="subject"
                                                    placeholder="Subject" formControlName="subject">
                                            </div>
                                        </div>
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <textarea name="message" class="form-control" id="message" cols="30"
                                                    rows="4" placeholder="Create a message here"
                                                    formControlName="message"></textarea>
                                            </div>
                                        </div>

                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <input type="button" value="Send Message" class="btn btn-primary"
                                                    (click)="submitForm()">
                                                <div class="submitting"></div>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div class="col-lg-6 d-flex align-items-stretch">
                            <div id="map" class="bg-white"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section> -->
<app-contact-us-model></app-contact-us-model>